import { Button } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import React from 'react'

import { Icons } from 'src/common/components'

import { organizationSelectorModal } from '../OrganizationSelectorModal/OrganizationSelectorModal.component'

const SwitchOrganizaitonButton = () => {
  return (
    <Button
      onClick={() => organizationSelectorModal()}
      px="md"
      leftSection={<Icons.Reload />}
      variant="filled"
    >
      Switch Organization
    </Button>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  SwitchOrganizaitonButton,
  'is_enable_select_organization',
  true,
)
